import { ArrowLeft, ArrowRight, CheckCircle2 } from "lucide-react";

export function OnboardingFooter({
  onBack,
  onNext,
  backLabel,
  nextLabel,
  nextDisabled = false,
  showBack = true,
  centerMessage,
  finish = false,
}) {
  return (
    <div className="mt-10 border-t border-[#e5e7eb] pt-6">
      <div
        className={[
          "flex flex-col gap-4 sm:flex-row sm:items-center",
          showBack ? "sm:justify-between" : "sm:justify-end",
        ].join(" ")}
      >
        {showBack ? (
          <button
            type="button"
            onClick={onBack}
            className="inline-flex h-11 items-center justify-center gap-2 rounded-full border px-5 text-sm font-semibold transition hover:bg-[#fff9ee]"
            style={{
              borderColor: "#D4A574",
              color: "#9A5B2E",
            }}
          >
            <ArrowLeft className="h-4 w-4" aria-hidden />
            {backLabel}
          </button>
        ) : null}

        {centerMessage ? (
          <p className="text-center text-xs text-[#9CA3AF] sm:flex-1">
            {centerMessage}
          </p>
        ) : (
          <span className="hidden sm:block sm:flex-1" />
        )}

        <button
          type="button"
          onClick={onNext}
          disabled={nextDisabled}
          className="inline-flex h-11 items-center justify-center gap-2 rounded-full bg-primary px-6 text-sm font-semibold text-white shadow-[0px_8px_24px_rgba(245,158,11,0.3)] transition hover:bg-primary-hover hover:shadow-[0px_8px_24px_rgba(135,83,0,0.3)] active:bg-primary-active active:shadow-[0px_8px_24px_rgba(72,44,0,0.3)] disabled:cursor-not-allowed disabled:bg-primary-disabled disabled:shadow-none"
        >
          {nextLabel}
          {finish ? (
            <CheckCircle2 className="h-4 w-4" aria-hidden />
          ) : (
            <ArrowRight className="h-4 w-4" aria-hidden />
          )}
        </button>
      </div>
    </div>
  );
}
